import styled from 'styled-components'
import Icon from 'src/components/Icon'
import { mq, sizes } from 'src/theme'

export const Container = styled.div`
  line-height: 1.6;
  cursor: pointer;
  @media ${mq(sizes.tablet)} {
    position: relative;
  }
`

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const CustomHighlight = styled.span<{
  color?: string
  backgroundColor?: string
}>`
  display: flex;
  align-items: center;
  padding: 0.1em;
  box-decoration-break: clone;
  color: ${({ color, theme }) => (color ? color : theme.colors.pureBlack)};
  background-color: ${({ theme, backgroundColor }) =>
    backgroundColor ? backgroundColor : theme.colors.pureWhite};
  text-decoration: underline;
  & br {
    display: block !important;
  }
  @media ${mq(sizes.tablet)} {
    display: inline;
  }
`

export const CustomIcon = styled(Icon)`
  width: 2.2rem;
  height: 2.2rem;
  margin-left: 0.5rem;
  & svg {
    width: 2.2rem;
    height: 2.2rem;
  }
`

export const OptionsWrapper = styled.div<{
  color?: string
  backgroundColor?: string
  $isOpened: boolean
}>`
  visibility: ${({ $isOpened }) => ($isOpened ? 'visible' : 'hidden')};
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 6;
  color: ${({ color, theme }) => (color ? color : theme.colors.pureBlack)};
  background-color: ${({ theme, backgroundColor }) =>
    backgroundColor ? backgroundColor : theme.colors.pureWhite};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 1.5rem 0;
  @media ${mq(sizes.tablet)} {
    position: fixed;
  }
`

export const OptionsTitle = styled.div`
  ${({ theme }) => theme.textStyles.text_14};
  font-weight: 600;
  text-align: left;
  padding: 0.1rem 1rem 0.1rem 2.2rem;
  @media ${mq(sizes.tablet)} {
    ${({ theme }) => theme.textStyles.text_18};
    font-weight: 600;
  }
`

export const OptionWrapper = styled.div`
  width: 100%;
`

export const Option = styled.div`
  ${({ theme }) => theme.textStyles.text_14};
  font-weight: 400;
  padding: 0.1rem 2.2rem;
  text-align: left;
  cursor: pointer;
  &:hover {
    font-weight: 700;
    background-color: rgba(255, 255, 255, 0.6);
  }
  @media ${mq(sizes.tablet)} {
    ${({ theme }) => theme.textStyles.text_16};
  }
`
